import * as o from "react";
import { c as y } from "./index-DLeNytVF.js";
import { P as g, d as z } from "./index-BrTLHETv.js";
import { u as w } from "./index-DLcqcWxM.js";
import { u as m } from "./index-DwYXX2sM.js";
import { jsx as B } from "react/jsx-runtime";
function H(r, e = globalThis == null ? void 0 : globalThis.document) {
  const s = m(r);
  o.useEffect(() => {
    const n = (t) => {
      t.key === "Escape" && s(t);
    };
    return e.addEventListener("keydown", n, { capture: !0 }), () => e.removeEventListener("keydown", n, { capture: !0 });
  }, [s, e]);
}
var M = "DismissableLayer", p = "dismissableLayer.update", K = "dismissableLayer.pointerDownOutside", j = "dismissableLayer.focusOutside", O, T = o.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), x = o.forwardRef(
  (r, e) => {
    const {
      disableOutsidePointerEvents: s = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: t,
      onFocusOutside: a,
      onInteractOutside: l,
      onDismiss: d,
      ...v
    } = r, c = o.useContext(T), [u, W] = o.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, k] = o.useState({}), A = w(e, (i) => W(i)), b = Array.from(c.layers), [N] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), I = b.indexOf(N), P = u ? b.indexOf(u) : -1, _ = c.layersWithOutsidePointerEventsDisabled.size > 0, D = P >= I, U = Y((i) => {
      const E = i.target, C = [...c.branches].some((h) => h.contains(E));
      !D || C || (t == null || t(i), l == null || l(i), i.defaultPrevented || d == null || d());
    }, f), L = q((i) => {
      const E = i.target;
      [...c.branches].some((h) => h.contains(E)) || (a == null || a(i), l == null || l(i), i.defaultPrevented || d == null || d());
    }, f);
    return H((i) => {
      P === c.layers.size - 1 && (n == null || n(i), !i.defaultPrevented && d && (i.preventDefault(), d()));
    }, f), o.useEffect(() => {
      if (u)
        return s && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (O = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), R(), () => {
          s && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = O);
        };
    }, [u, f, s, c]), o.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), R());
    }, [u, c]), o.useEffect(() => {
      const i = () => k({});
      return document.addEventListener(p, i), () => document.removeEventListener(p, i);
    }, []), /* @__PURE__ */ B(
      g.div,
      {
        ...v,
        ref: A,
        style: {
          pointerEvents: _ ? D ? "auto" : "none" : void 0,
          ...r.style
        },
        onFocusCapture: y(r.onFocusCapture, L.onFocusCapture),
        onBlurCapture: y(r.onBlurCapture, L.onBlurCapture),
        onPointerDownCapture: y(
          r.onPointerDownCapture,
          U.onPointerDownCapture
        )
      }
    );
  }
);
x.displayName = M;
var X = "DismissableLayerBranch", S = o.forwardRef((r, e) => {
  const s = o.useContext(T), n = o.useRef(null), t = w(e, n);
  return o.useEffect(() => {
    const a = n.current;
    if (a)
      return s.branches.add(a), () => {
        s.branches.delete(a);
      };
  }, [s.branches]), /* @__PURE__ */ B(g.div, { ...r, ref: t });
});
S.displayName = X;
function Y(r, e = globalThis == null ? void 0 : globalThis.document) {
  const s = m(r), n = o.useRef(!1), t = o.useRef(() => {
  });
  return o.useEffect(() => {
    const a = (d) => {
      if (d.target && !n.current) {
        let v = function() {
          F(
            K,
            s,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: d };
        d.pointerType === "touch" ? (e.removeEventListener("click", t.current), t.current = v, e.addEventListener("click", t.current, { once: !0 })) : v();
      } else
        e.removeEventListener("click", t.current);
      n.current = !1;
    }, l = window.setTimeout(() => {
      e.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(l), e.removeEventListener("pointerdown", a), e.removeEventListener("click", t.current);
    };
  }, [e, s]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function q(r, e = globalThis == null ? void 0 : globalThis.document) {
  const s = m(r), n = o.useRef(!1);
  return o.useEffect(() => {
    const t = (a) => {
      a.target && !n.current && F(j, s, { originalEvent: a }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", t), () => e.removeEventListener("focusin", t);
  }, [e, s]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function R() {
  const r = new CustomEvent(p);
  document.dispatchEvent(r);
}
function F(r, e, s, { discrete: n }) {
  const t = s.originalEvent.target, a = new CustomEvent(r, { bubbles: !1, cancelable: !0, detail: s });
  e && t.addEventListener(r, e, { once: !0 }), n ? z(t, a) : t.dispatchEvent(a);
}
var $ = x, ee = S;
export {
  ee as B,
  x as D,
  $ as R
};
//# sourceMappingURL=index-Dz0AUfZX.js.map
